import i18n from 'i18next';
// import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

import { CONSTANT_LANGUAGE_LIST, LANGUAGE } from 'utils/constants';

// import bundledResources from 'utils/localTranslation';

export function detectLanguage() {
  const { pathname } = window.location;
  const lang = pathname.split('/')[1];

  if (lang && CONSTANT_LANGUAGE_LIST.includes(lang)) {
    window.localStorage.setItem(LANGUAGE, lang);
    return lang;
  }
  return 'vi';
}

export function initLanguage() {
  const { pathname } = window.location;
  const lang = pathname.split('/')[1];

  if (lang && CONSTANT_LANGUAGE_LIST.includes(lang)) {
    window.localStorage.setItem(LANGUAGE, lang);
    return lang;
  }
  window.localStorage.setItem(LANGUAGE, 'vi');
  return 'vi';
}

i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: 'vi',
    lng: initLanguage(), // Detect not work, if lng turn on
    interpolation: {
      escapeValue: false,
      formatSeparator: '.',
    },
    // detection: {
    //   order: ['path'],
    //   lookupFromPathIndex: 0,
    //   lookupLocalStorage: LANGUAGE,
    // },
    // resources: {},
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: `${process.env.REACT_APP_API_BASE_URL}fe-translations?locale={{lng}}`,
    },
    // ns: ['translation', 'local'],
    //! Only turn this defaultNS on when testing local static translation files
    // defaultNS: 'local',
  });

// eslint-disable-next-line no-restricted-syntax
// for (const lang of Object.keys(bundledResources)) {
//   i18n.addResources(lang, 'local', bundledResources[lang]);
// }

//! Only turn this function on when testing static translation files
// eslint-disable-next-line no-restricted-syntax
// for (const lang of Object.keys(staticBundledResources)) {
//   i18n.addResourceBundle(lang, 'local', staticBundledResources[lang]);
// }

export default i18n;
